const BASE = 'tn-events-list-view';
const INPUT_CONTAINER = `${BASE}__datepicker-container`;

const Class = {
  BASE,
  // INPUT_CONTAINER,
  INPUT_CONTAINER_FROM: `${INPUT_CONTAINER}--from`,
  INPUT_CONTAINER_TO: `${INPUT_CONTAINER}--to`,
  BTN_RESET: `${BASE}__btn-reset-dates`,
};

export default Class;
